import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { patientsRoute } from "../routes/reactRoutes";

const AuthRoute = ({ children }) => {
  const currentUser = useSelector((state) => state.authenticationValues.currentUser);
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser.firstName) {
      navigate(patientsRoute, { replace: true });
    }
  }, [currentUser, navigate]);

  return children;
};

export default AuthRoute;